import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

import ZOOMRESTAPIENDPOINTOPTIONS from "resources/img/zoom_rest_api_endpoint_options.png";
import ZOOMSERVERSDKAUTHENTICATIONFLOW from "resources/img/zoom_server_sdk_authentication_flow.png";
import ZOOMCOMPAT from "resources/img/zoom_compat_matrix.jpg";
import SERVER_ARCHITECTURE_AND_DATA_FLOW from "resources/img/zoom_server_architecture_and_data_flow.png";
import SERVER_DEDICATE_AND_CLOUD_ARCHITECTURE from "resources/img/zoom_server_dedicated_and_cloud_architecture.png";

export default React.createClass({
  displayName: "zoom-configuration-options",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
      scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container quick-guides-pages">

              <section>
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="technical-specifications-and-requirements">Technical Specifications and Requirements</h2>
                </div>
                <p>This page will give you various metrics about the FaceTec SDK and requirements for running it.</p>
                <hr/>
              </section>

              <section>
                <h3 id="general">General</h3>
                <br />
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-5">3D FaceMap Size</th>
                      <td className="col-xs-7"><p>~350KB (in transit) / ~100KB (stored on server) / ~400KB (max. due to continuous learning)</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">FaceMap Encryption</th>
                      <td className="col-xs-7"><p>Asymmetric RSA & Randomized AES-256</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Audit Image Size</th>
                      <td className="col-xs-7"><p>Typically 640px tall and ~50KB</p></td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </section>

              <section>
                <h3 id="device-sdk">Device SDK</h3>
                <br />
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-5">Min. iOS/Android/Browser Version</th>
                      <td className="col-xs-7"><p><Link to="/compatibility">See Compatibility Page</Link></p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Camera Requirements</th>
                      <td className="col-xs-7"><p>0.3 Megapixel (VGA) -- All Known Cameras</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. CPU</th>
                      <td className="col-xs-7"><p>iOS/Android - All armv7 and arm64.<br />Browser - No CPU constraints.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. GPU</th>
                      <td className="col-xs-7"><p>No requirements</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Memory</th>
                      <td className="col-xs-7"><p>No known device incompatibility due to memory</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Disk</th>
                      <td className="col-xs-7"><p>No known device incompatibility due to disk</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">iOS and Android Size Add to Your App</th>
                      <td className="col-xs-7"><p><Link to="zoom-sdk-size-and-app-thinning">~6.5MB</Link></p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Browser Size Add to Your App</th>
                      <td className="col-xs-7"><p><Link to="zoom-sdk-size-and-app-thinning">~3MB</Link></p></td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </section>

              <section>
                <h3 id="server-sdk">Server SDK</h3>
                <br />
                <blockquote><strong>New!</strong> <strong>FaceTec Standard Server</strong> and <strong>Server Dashboard</strong> are new packages available from FaceTec.  Please see the <Link to="/server-sdk-overview">Server SDK Overview</Link> page for more details.</blockquote>
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-5">Operating System (FaceTec Server Core SDK)</th>
                      <td className="col-xs-7"><p>Most Modern Linux Distros + Java SDK + libgomp</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Windows Supported</th>
                      <td className="col-xs-7"><p>Yes, via Docker</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Mac Supported</th>
                      <td className="col-xs-7"><p>Yes, via Docker</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Linux Supported</th>
                      <td className="col-xs-7"><p>Yes, via Docker</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">FaceTec Server Core SDK Integration Type</th>
                      <td className="col-xs-7"><p>Linux Java JAR</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">FaceTec REST Sample Code Language</th>
                      <td className="col-xs-7"><p>Java</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. iOS/Android/Browser Version</th>
                      <td className="col-xs-7"><p><Link to="/compatibility">See Compatibility Page</Link></p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. CPU</th>
                      <td className="col-xs-7"><p>4 Servers, each running 8-core Intel Xeon Platinum 8000 Series CPUs.  This achieves 20 Liveness Checks per Second (1.7 Million per day).  </p></td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </section>

              <section>
                <h3 id="server-hardware">Server Hardware</h3>
                <br />
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-5">Min. Server CPU</th>
                      <td className="col-xs-7"><p>8-core Xeon Platinum 8000 Series CPU.</p><p class="small">FaceTec utilizes AI features on <a href="https://www.intel.com/content/www/us/en/products/processors/xeon/scalable/platinum-processors.html">Intel Xeon Platinum CPUs</a> to speed up operations.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Server Memory<br />(Liveness/Enrollment/Authentication/Photo ID Match)</th>
                      <td className="col-xs-7"><p>16GB</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Server Memory<br />(Search)</th>
                      <td className="col-xs-7"><p>16GB + 5GB per 1 Million Enrollments</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Server Disk Space (Liveness Detection Only)</th>
                      <td className="col-xs-7"><p>20GB</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Server Disk Space<br />(Enrollment/Authentication/Photo ID Match)</th>
                      <td className="col-xs-7"><p>20GB**</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. Server Disk Space<br />(Search)</th>
                      <td className="col-xs-7"><p>20GB + 5GB per 1 Million Enrollments</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Server Networking</th>
                      <td className="col-xs-7"><p>GB+ Internal Adapters/Networks Recommended</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Virtualization</th>
                      <td className="col-xs-7"><p>Supported.</p><p>Please note some VM configurations do not allow leveraging CPU hardware acceleration and should be tested.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Min. GPU</th>
                      <td className="col-xs-7"><p>No GPU requirements.</p></td>
                    </tr>
                  </tbody>
                </table>
                <blockquote>
                  <p>* Higher or lower tier CPUs supported but performance and stability may vary.</p>
                  <p>** Assumes 3D FaceMaps (Enrollments) are stored in a Customer's database or external filesystem.</p>
                  <p>Please see the <Link to="server-integration">Server Integration Guide</Link> for more details on architectural considerations based on your use case.</p>
                </blockquote>
                <hr />
              </section>


              <section>
                <h3 id="databases-and-storage">Databases</h3>
                <br />
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-5">FaceTec Standard Server and Server Dashboard SDKs</th>
                      <td className="col-xs-7"><p>MongoDB is required.  Support coming for SQL and other Cloud Provider-specific technologies.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">REST Sample Code FaceMap Storage</th>
                      <td className="col-xs-7"><p>Basic Local Filesystem or S3 - Sample Code Provided</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">REST Sample Code Audit Image and ID Scan Storage</th>
                      <td className="col-xs-7"><p>Basic Local Filesystem or S3  - Sample Code Provided</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">AWS DB/Storage Support</th>
                      <td className="col-xs-7"><p>S3, DynamoDB, DocumentDB, RDS, Aurora, and more.<br />Supported via customizing Server SDK code.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Google Cloud DB/Storage Support</th>
                      <td className="col-xs-7"><p>SQL, Bigtable, and more.<br />Supported via customizing Server SDK code.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Azure DB/Storage Support</th>
                      <td className="col-xs-7"><p>SQL, Cosmos, and more.<br />Supported via customizing Server SDK code.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Other DB/Storage Support</th>
                      <td className="col-xs-7"><p>MongoDB, PostgreSQL, MySQL, and more.<br />Supported via customizing Server SDK code.</p></td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </section>


              <section>
                <h3 id="data-types-and-storage">Data Types and Storage</h3>
                <p><strong>In Standard Server</strong>, data is stored via prescriptive, internal logic.  The Database is owned wholly by the Customer, and you have 100% control over data retention policy.  Standard Server stores FaceMaps, images, and other metadata by default in order to support the Server Dashboard GUI.</p>
                <p><strong>In Custom Server</strong>, data is stored via code that you own and implement.  Database storage, retrieval, and what additional metadata is stored is 100% configurable and designed by the Customer.  The REST Sample Code provides initial reference sample code. MongoDB is not required for FaceTec Custom Server -- You may implement any database and storage technology.</p>
                <p><Link to="/zoom-configuration-options?link=standard-vs-custom">More Information about Standard vs. Custom Server</Link></p>
                <br />
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-3">Data Type</th>
                      <th className="col-xs-3">Description</th>
                      <th className="col-xs-6">Notes</th>
                    </tr>
                    <tr>
                      <th className="col-xs-3"><strong>3D FaceMaps</strong></th>
                      <td className="col-xs-3"><p>Encrypted Biometric from Liveness Check.</p></td>
                      <td className="col-xs-6"><p>Required to perform Liveness Checks, Enrollment, Authentication, and Photo ID Matching.  Storage is required for Enrollment, Authentication, and Photo ID Matching.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-3"><strong>2D Audit Trail Images</strong></th>
                      <td className="col-xs-3"><p>Image Data from User Session.</p></td>
                      <td className="col-xs-6"><p>Required for certain Security Checks.  Stored by default in Standard Server.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-3"><strong>ID Scans</strong></th>
                      <td className="col-xs-3"><p>Encrypted data from Photo ID Match Session.</p></td>
                      <td className="col-xs-6"><p>Allows 1/500,000 FAR 3D FaceMap to Photo ID Matching with ID Anti-Spoofing.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-3"><strong>ID Scan Images</strong></th>
                      <td className="col-xs-3"><p>Front and Back Images of User ID.</p></td>
                      <td className="col-xs-6"><p>Can be used to perform additional ID Verification.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-3"><strong>Additional Metadata</strong></th>
                      <td className="col-xs-3"><p>e.g. FaceTec Version, IP Addresses, Device Models.</p></td>
                      <td className="col-xs-6"><p>Required for Server Dashboard display.  100% configurable and optional in Custom SDKs.</p></td>
                    </tr>
                  </tbody>
                </table>
                <hr />
              </section>


              <section>
                <h3 id="server-benchmarks-and-costs">Server Benchmarks & Costs</h3>
                <br />
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-5">Baseline Cluster Specs</th>
                      <td className="col-xs-7"><p>4 Servers, each running 8-core Intel Xeon Platinum 8000 Series CPUs</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Liveness Check Throughput (Baseline Cluster)*</th>
                      <td className="col-xs-7"><p>~1.7 Million Liveness Checks per day (20 per second)</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Search Throughput (Baseline Cluster)*</th>
                      <td className="col-xs-7"><p>~150,000 Searches per day (2 per second) [1,000,000 Enrollments]</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">AWS Cluster Machine Type</th>
                      <td className="col-xs-7"><p>C5.2xlarge</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Azure Cluster Machine Type</th>
                      <td className="col-xs-7"><p>F8s v2</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Google Cloud Cluster Machine Type</th>
                      <td className="col-xs-7"><p>n1-highcpu-8</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Compute Cost (Baseline Cluster)</th>
                      <td className="col-xs-7"><p>AWS/Google: $4000-$5200 annually</p></td>
                    </tr>
                  </tbody>
                </table>
                <blockquote>
                  <p>* Benchmarks assume cluster is set up specifically for Liveness or Search tasks, not both simultaneously.</p>
                </blockquote>
                <hr />
              </section>

              <section>
                <h3 id="cloud-providers-and-misc-technologies">Cloud Providers & Misc. Technologies</h3>
                <br />
                <table width="100%" className="specs-table">
                  <tbody>
                    <tr>
                      <th className="col-xs-5">Custom Windows Servers</th>
                      <td className="col-xs-7"><p>Supported, via Docker</p></td>
                    </tr>
                    <tr>
                    <th className="col-xs-5">Custom Linux Servers</th>
                    <td className="col-xs-7"><p>Supported, via Docker</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">AWS EC2</th>
                      <td className="col-xs-7"><p>Supported, Standard Server Recommended</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">AWS EB</th>
                      <td className="col-xs-7"><p>Supported, Standard Server Recommended</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">AWS Lambda</th>
                      <td className="col-xs-7"><p>Not Supported due to Lambda app size restriction.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">AWS Fargate</th>
                      <td className="col-xs-7"><p>Supported*</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Kubernetes</th>
                      <td className="col-xs-7"><p>Supported*</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">AWS Lambda</th>
                      <td className="col-xs-7"><p>Not Supported due to Lambda app size restriction.</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Google Compute Engine</th>
                      <td className="col-xs-7"><p>Supported, Standard Server Recommended*</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Azure VMs</th>
                      <td className="col-xs-7"><p>Supported, Standard Server Recommended*</p></td>
                    </tr>
                    <tr>
                      <th className="col-xs-5">Azure App Service</th>
                      <td className="col-xs-7"><p>Supported, Standard Server Recommended*</p></td>
                    </tr>
                  </tbody>
                </table>
                <blockquote>
                  <p>* Known deployments exist (Partner, Customer, etc.) with this technology.</p>
                </blockquote>
                <br />
              </section>

              <SDKSidebar menuType="main" title="Technical Specs"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/technical-specs.jsx